module.exports = __webpack_public_path__ + "static/media/loading.b5f44470.gif";